import * as React from "react";
import * as ReactDOM from "react-dom";

import * as actions from "../shared/timeclock/actions";
import { DesktopApplication } from "./components";
import { api as oldApi } from "../shared/timeclock/services";
import { initialize } from "../shared/timeplan-api-client";

import { createPersistedStore } from "./store";

// Polyfills needed for Chromium 64
import "@formatjs/intl-locale/polyfill";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/sv";

import "./maptheme.scss";

require("expose-loader?exposes=jQuery!jquery");
require("../node_modules/signalr/jquery.signalR.js");

if ("serviceWorker" in navigator) {
    window.addEventListener("load", async () => {
        try {
            const registration = await navigator.serviceWorker.register(
                "/Timeplan.MainWeb/timeclock_sw.bundle.js",
                { scope: location.pathname });

            console.log("SW registered: ", registration);
        } catch (registrationError) {
            console.log("SW registration failed: ", registrationError);
        }
    });
}

window.onload = () => {

    const dataNode = document.getElementById("terminalData") as HTMLInputElement;

    const store = createPersistedStore(dataNode.value);

    // helpful shortcut for developers :)
    global["viewsettings"] = () => store.dispatch({ type: actions.SETTINGS_OPEN });
    
    const { config } = store.getState();
    const apiUrl = config.serverUrl.slice(0, -3);
    
    initialize({ apiUrl, rootUrl: null, apiV1Url: null });
    oldApi.initialize(config.serverUrl);

    ReactDOM.render(<DesktopApplication store={store} />, document.getElementById("content"));
};
